module.exports = __webpack_public_path__ + "static/media/icon_left_arrow_in_circle.89ad57b5.svg";